import styled, { css } from 'styled-components'

const Link = styled.a`
  margin-left: 10px;
  color: ${props => props.theme.color.palette['brand-1']};
  text-decoration: underline;
  font-weight: ${props => props.theme.font.weight.bold};

  &:hover {
    color: ${props => props.theme.color.palette['brand-1-dark']};
  }
`
const TuLink = styled(Link)`
  text-decoration: none;
  font-weight: ${props => props.theme.font.weight.regular};
  margin-left: 5px;
`
const Wrapper = styled.div`
  display: flex;
  align-items: center;

  &&& button.bv_main_container_row_flex {
    display: none !important;
  }

  &&& button.bv_war_button {
    font-family: ${props => props.theme.font.family.base} !important;
    color: ${props => props.theme.color.palette['brand-1']} !important;
    font-weight: ${props => props.theme.font.weight.bold} !important;
    line-height: ${props => props.theme.font['line-height'].base} !important;
  }
`

const StarRatingWrapper = styled.span`
  display: flex;
  cursor: pointer;
  margin-top: 10px;

  &&& div[data-bv-show='rating_summary'] {
    margin-left: ${props => props.theme.size.spacing.md} !important;
  }

  ${({ isLinkMessageShown }) =>
    isLinkMessageShown &&
    css`
      flex-direction: column;

      &&& div[data-bv-show='rating_summary'] {
        margin-left: 0 !important;
      }

      @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
        flex-direction: row;

        &&& div[data-bv-show='rating_summary'] {
          margin-left: ${props => props.theme.size.spacing.md} !important;
        }
      }
    `}
`

export { Link, TuLink, Wrapper, StarRatingWrapper }
